module.exports = __webpack_public_path__ + "img/icon-tag.bfe1f62.svg";